import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  ImagesService,
  RotateScannerImagesResponse,
} from '@services/ImagesService'

export const rotateScannerImages = createAsyncThunk<
  RotateScannerImagesResponse,
  { images: string[]; angle: number }
>('scanner/rotateScannerImages', async (params, { rejectWithValue }) => {
  try {
    return await ImagesService.rotateScannerImages(params)
  } catch (error: any) {
    return rejectWithValue(error?.message ?? 'Rotation failed')
  }
})
